import ActionPlanDashboard from '../../components/action_plans/ActionPlanDashboard'
import HowToVideo from '../../components/HowToVideo'
import { createApp } from 'vue';
import BootstrapVueNext from 'bootstrap-vue-next'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'

if (document.getElementById('action-plan-dashbard-container')) {
    const app = createApp({
        data() {
            return {
              video: {
                title: 'Go NAPSACC How-To Video: Action Planning',
                assessmentURL:
                  'https://www.youtube.com/embed/z8z_KIq27Oo?ecver=2&modestbranding=1&autoplay=0&showinfo=0&enablejsapi=1&rel=0',
              },
            };
          },
          components: {
            ActionPlanDashboard,
            HowToVideo,
        },
        methods: {
        },
        mounted() {
        }
    });
    app.use(BootstrapVueNext);
    app.mount('#action-plan-dashbard-container');

}
